import React from 'react'
import cs from "classnames";
import BirthdayPackages from '../../organisms/BirthdayPackages/BirthdayPackages';
import classes from "./BirthdayPackagesPage.module.scss"
import MyMaorLayout from '../../templates/MyMaorLayout';
import { isMobile } from 'react-device-detect';

const BirthdayPackagesPage = () => {
    return (
        <MyMaorLayout>
            <div className={cs("minh-100vh", classes.packagesSec, isMobile ? classes.mobilePackagesSec : "")}>
                <div
                    className={cs(
                        classes.wrapper,
                        "d-flex fd-column jc-center ai-center"
                    )}
                >
                    <div id="birthday-package" className={cs(classes.sectionTitle)}>
                        <div>
                            <h2 className={cs(classes.pinkColor, "mb-03")}>
                                Make Your child&apos;s birthday special!
                            </h2>
                            <h3>
                                Take your childs special day to the next level by combining{" "}
                                <span className={cs(classes.greenColor, "fw-700")}>
                                    meaning & a thrilling gift.
                                </span>
                            </h3>
                        </div>
                    </div>
                </div>
                <BirthdayPackages />
            </div>
        </MyMaorLayout>
    )
}

export default BirthdayPackagesPage